// extracted by mini-css-extract-plugin
module.exports = {"adWrapper":"ads_adWrapper__ad3rp"};